import { toast } from 'react-toastify';
import validator from 'validator';

export default {
  ValidateForm(form) {
    if(!form.name) {
      toast.warning("Name is empty!")
      return false

    } else if(!form.type) {
      toast.warning("Type is empty!")
      return false

    } else if(!form.phone) {
      toast.warning("Phone is empty!")
      return false

    } else if(!form.mobile) {
      toast.warning("Mobile is empty!")
      return false

    } else if(!validator.isEmail(form.email)) {
      toast.warning("Wrong email format!")
      return false

    } else if(!validator.isURL(form.website, {protocols: ['http', 'https'], require_protocol:true})) {
      toast.warning("Wrong website url!")
      return false

    } else if(!form.company_name) {
      toast.warning("Company name is empty!")
      return false

    } else if(!form.company_phone) {
      toast.warning("Company phone is empty!")
      return false

    } else if(!form.city) {
      toast.warning("City is empty!")
      return false

    } else if(!form.postal) {
      toast.warning("Postal is empty!")
      return false

    } else if(!form.address) {
      toast.warning("Address is empty!")
      return false

    } else if(!form.address2) {
      toast.warning("Address 2 is empty!")
      return false

    } else if(!form.business_model) {
      toast.warning("Bussiness model is empty!")
      return false
    }

    return true
  }
}



// WEBPACK FOOTER //
// ./src/App/tenant/tenant/helper/form.js